module.exports = __webpack_public_path__ + "static/media/arrow-down.60438593.svg";